import React, { useEffect } from "react";
import "./Customer.css";
import { Placeholder } from "react-bootstrap";

function CustomerTable({
  data,
  headerLabel,
  dataForGraph,
  dataForTable,
  setGraph,
  setSubTable,
  setHeader,
}) {
  const header = [
    "Time",
    headerLabel,
    "1 Order",
    "2 Orders",
    "3 Orders",
    "3+ Orders",
  ];

  const timeLabels = [
    "Today",
    "Yesterday",
    "2 days ago",
    "Last week",
    "Last month",
  ];
  useEffect(()=>{

  },[data])
  return (
    <table className="d-flex flex-column m-2">
      <thead
        className="d-flex text-gray border-primary border-2 border p-2 mb-2 rounded"
        style={{ background: "rgba(44, 123, 229, .1)" }}
      >
        <tr className="flex-1 d-flex justify-content-between ">
          {header.map((column, index) => (
            <th className="flex-1 text-center" key={index}>
              {column}
            </th>
          ))}
        </tr>
      </thead>

      {data.length ? (
        <tbody className="d-flex flex-column">
          {data.map((row, index) => (
            <tr
              id="table-row-value"
              onClick={() => {
                setGraph(dataForGraph[index]);
                setSubTable(dataForTable[index]);
                setHeader(timeLabels[index]);
              }}
              className="flex-1 rounded my-1  d-flex justify-content-between "
              key={index}
            >
              <td
                style={{ background: "rgba(44, 123, 229, .1)" }}
                className="flex-1 p-3 py-2 text-secondary text-center text-truncate w-100"
              >
                {timeLabels[index]}
              </td>
              {row.map(
                (value, index) =>
                  value !== undefined && (
                    <td
                      style={{ padding: ".8rem 1.5rem" }}
                      className="flex-1 fw-bold text-primary text-center"
                      key={index}
                    >
                      {value}
                    </td>
                  )
              )}
            </tr>
          ))}
        </tbody>
      ) : (
        <tbody className="d-flex flex-column">
          {timeLabels.map((label, index) => (
            <tr
              id="table-row-value"
              className="flex-1 rounded my-1  d-flex justify-content-between "
              key={index}
            >
              <td
                style={{ background: "rgba(44, 123, 229, .1)" }}
                className="flex-1 p-3 py-2 text-secondary text-center text-truncate w-100"
              >
                {label}
              </td>

              <td
                style={{ padding: ".3rem 1.5rem", width: "42rem" }}
                className="flex-fill fw-bold text-primary text-center"
                key={index}
              >
                <Placeholder as="p" animation="wave">
                  <Placeholder xs={12} />
                </Placeholder>
              </td>
            </tr>
          ))}
        </tbody>
      )}
    </table>
  );
}

export default CustomerTable;
